import { HttpResponse } from '@capacitor/core';

export default class AuthenticationError extends Error {
  constructor(public response: HttpResponse) {
    super();
  }
}
